import VenueNoAccessCalendarController from "./venue_no_access_calendar_controller"

export default class extends VenueNoAccessCalendarController {}
